import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";
import { handleUploadFile } from "../../helpers/helpers";

export const uploadJVFile = createAsyncThunk(
  "jointVentures/uploadJVFile",
  async ({ file, folderPath }, { rejectWithValue }) => {
    try {
      const { fileUrl, fileName } = await handleUploadFile(file, folderPath);
      return { fileName, fileType: file.type, folderPath, fileUrl };
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to upload file");
    }
  }
);

export const submitDeal = createAsyncThunk(
  "jointVentures/submitDeal",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axios.post("/api/admin/deals/joint-venture", payload);
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const dealAutofill = createAsyncThunk(
  "jointVentures/dealAutofill",
  async (arg, { rejectWithValue }) => {
    try {
      const orgId = typeof arg === "string" ? arg : arg?.orgId;
      const dealId = typeof arg === "object" && arg ? arg.dealId : undefined;
      const response = await axios.get(`/api/admin/JV/dealAutofill/${orgId}`, {
        params: dealId ? { dealId } : undefined,
      });
      // httpConfig already unwraps to API body: { statusCode, message, response }
      return response?.response ?? null;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

const jointVenturesSlice = createSlice({
  name: "jointVentures",
  initialState: {
    loading: false,
    error: null,
    success: false,
    dealAutofillList: null,
  },
  reducers: {
    resetDealAutofill: (state) => {
      state.dealAutofillList = null;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitDeal.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(submitDeal.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.dealAutofillList = null;
      })
      .addCase(submitDeal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });

    builder.addCase(dealAutofill.pending, (state) => {
      state.loading = true;
      state.error = "";
      state.dealAutofillList = null;
    });
    builder.addCase(dealAutofill.fulfilled, (state, action) => {
      state.loading = false;
      state.error = "";
      state.dealAutofillList = action.payload;
    });
    builder.addCase(dealAutofill.rejected, (state, action) => {
      state.loading = false;
      state.dealAutofillList = null;
      state.error = action.payload;
    });
  },
});

export const { resetDealAutofill } = jointVenturesSlice.actions;
export default jointVenturesSlice.reducer;

